import {
  FileSpreadsheet, FileText, FileType, Image as ImageIcon, Table,
} from 'lucide-react';

/**
 * Anzeigehelfer für das Dokumente-Modul (bewusst lokale Kopie der
 * rechnungen-Muster — Cross-Modul-Kopplung über gridCells vermeiden;
 * einzig die generische Lightbox wird aus rechnungen importiert).
 */

export type DocumentMimeGroup = 'image' | 'pdf' | 'sheet' | 'document' | 'other';

export const documentMimeGroup = (mime: string | null, name: string | null): DocumentMimeGroup => {
  const m = (mime ?? '').toLowerCase();
  if (m.startsWith('image/')) return 'image';
  if (m.includes('pdf')) return 'pdf';
  if (m.includes('spreadsheet') || m.includes('ms-excel') || /\.(xlsx?|csv)$/i.test(name ?? '')) return 'sheet';
  if (m.includes('wordprocessing') || m.includes('msword') || /\.docx?$/i.test(name ?? '')) return 'document';
  return 'other';
};

export const documentGroupIcon: Record<DocumentMimeGroup, typeof FileText> = {
  image: ImageIcon,
  pdf: FileText,
  sheet: FileSpreadsheet,
  document: FileType,
  other: Table,
};

export const formatFileSize = (bytes: number | null): string => {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** Allowlist = FileStorageService COMMON_MIMES (identisch für rechnungen + dokumente). */
export const DOCUMENT_ACCEPT =
  'application/pdf,image/jpeg,image/png,image/gif,image/webp,' +
  'text/csv,text/plain,' +
  'application/vnd.ms-excel,' +
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/msword,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';